import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Container, Grid, TAGTypography } from '../../';
import Service from './Service';

var ServiceGroup = function ServiceGroup(_ref) {
  var description = _ref.description,
      services = _ref.services,
      title = _ref.title;
  return React.createElement(Grid, {
    container: true,
    sx: {
      padding: '40px 0'
    }
  }, title && React.createElement(Container, null, React.createElement(TAGTypography, {
    color: "primary",
    variant: "h2",
    sx: {
      textAlign: 'center',
      mb: '40px'
    }
  }, title)), (description === null || description === void 0 ? void 0 : description.description) && React.createElement(Container, {
    sx: {
      textAlign: 'center'
    }
  }, React.createElement("p", null, React.createElement(TAGTypography, {
    color: "primary",
    variant: "bodyXLargeBook",
    sx: {
      mb: '20px'
    }
  }, description.description))), services.map(function (service, index) {
    return React.createElement(Service, _objectSpread({
      key: "".concat(service.contentful_id).concat(index)
    }, service));
  }));
};

export default ServiceGroup;